export default __webpack_public_path__ + "static/media/25-ART-(3-2).9065498f.jpg";